module.exports = __webpack_public_path__ + "static/media/peghook.b76fa3f6.png";